export const FETCH_PHONES_START = 'FETCH_PHONES_START';
export const FETCH_PHONES_SUCCESS = 'FETCH_PHONES_SUCCESS';
export const FETCH_PHONES_FAILURE = 'FETCH_PHONES_FAILURE';

export const LOAD_MORE_PHONES_START = 'LOAD_MORE_PHONES_START';
export const LOAD_MORE_PHONES_SUCCESS = 'LOAD_MORE_PHONES_SUCCESS';
export const LOAD_MORE_PHONES_FAILURE = 'LOAD_MORE_PHONES_FAILURE';

export const FETCH_PHONE_BY_ID_START = 'FETCH_PHONE_BY_ID_START';
export const FETCH_PHONE_BY_ID_SUCCESS = 'FETCH_PHONE_BY_ID_SUCCESS';
export const FETCH_PHONE_BY_ID_FAILURE = 'FETCH_PHONE_BY_ID_FAILURE';

export const ADD_PHONE_TO_CART = 'ADD_PHONE_TO_CART';

export const SEARCH_PHONE = 'SEARCH_PHONE';

export const GET_NEWS = 'GET_NEWS';
export const NEWS_RECEIVED = 'NEWS_RECEIVED';


export const FETCH_CATEGORIES_START = 'FETCH_CATEGORIES_START';
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILURE = 'FETCH_CATEGORIES_FAILURE';

export const REMOVE_PHONE_FROM_CART = 'REMOVE_PHONE_FROM_CART';

export const CLEAR_CART = 'CLEAR_CART';